import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
span.disclaimer {
  font-size: 12px;
  font-weight: 400;
  color: #111111;
    margin-top: 8px;
}
.title-section {
    border-bottom: 1px #d8d8d8 solid;
    padding-bottom: calc(8px * 2);
}
.title-container {
    display: flex;
}
.etf-tip-content {
    color: #000000;
    max-width: calc(8px * 79);
    width: 100%;
    padding: 8px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    -webkit-filter: contrast(21);
            filter: contrast(21);
    line-height: 1.15;
    display: flex;
}
.etf-tip-title {
    color: #000000;
    font-family: 'Nimbus Sans', sans-serif;
    line-height: 1;
    padding: 8px;
    justify-content: left;
    display: flex;
    font-size: 16px;
    font-weight: 600;
    float: left;
}
.premium-card-tooltip {
    padding-left: 8px;
    color: #000000;
}
.as-of-date {
    font-family: 'Nimbus Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    color: #475359;
}
.dividing-line {
    left: 33.8%;
    right: 49.32%;
    top: 10.64%;
    bottom: 89.28%;

    background: #d8d8d8;
    mix-blend-mode: normal;
    opacity: 0.4;
}
.chart-wrapper {
    border: 1px #d8d8d8 solid;
    margin: calc(8px * 2) auto;
    padding: 8px;
}
h2.premium-table-title {
    margin-top: 0;
    font-family: 'Nimbus Sans Light', sans-serif;
    font-weight: normal;
    text-align: center;
}
.premium-table-wrapper {
    margin: calc(8px * 3) auto;
}
`;

export default styles;